'use es6';

import createAction from 'flux-actions/createAction';
import { CHOSE_VARIATION_WINNER, CREATED_VARIATION, RECEIVED_VARIATIONS, REQUESTED_CHOOSE_VARIATION_WINNER, REQUESTED_CHOOSE_VARIATION_WINNER_FAILED, REQUESTED_CHOOSE_VARIATION_WINNER_SUCCEEDED, REQUESTED_CREATED_VARIATION, REQUESTED_CREATED_VARIATION_FAILED, REQUESTED_CREATED_VARIATION_SUCCEEDED, REQUESTED_RERUN_VARIATION, REQUESTED_RERUN_VARIATION_FAILED, REQUESTED_RERUN_VARIATION_SUCCEEDED, REQUESTED_VARIATIONS, REQUESTED_VARIATIONS_FAILED, RERAN_VARIATION } from './ActionTypes';
import { createTranslatedDangerNotification, createTranslatedSuccessNotification } from '../utils/alertUtils';
import { getUsageTrackerMeta } from '../utils/usageTracker';
export const requestVariations = createAction(REQUESTED_VARIATIONS);
export const receiveVariations = createAction(RECEIVED_VARIATIONS, variations => ({
  variations
}));
export const requestedVariationsFailed = createAction(REQUESTED_VARIATIONS_FAILED, error => ({
  error
}));
export const chooseVariationWinner = createAction(CHOSE_VARIATION_WINNER, ({
  abTestId,
  contentType,
  variationId
}) => ({
  abTestId,
  contentType,
  variationId
}));
export const requestChooseVariationWinner = createAction(REQUESTED_CHOOSE_VARIATION_WINNER);
export const requestedChooseVariationWinnerFailure = createAction(REQUESTED_CHOOSE_VARIATION_WINNER_FAILED, error => ({
  error
}), (error, contentType) => Object.assign({}, createTranslatedDangerNotification(contentType, 'chooseVariationWinner', error), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'chooseVariationWinner',
  'page-type': contentType,
  screen: 'detail',
  status: 'fail'
})));
export const requestedChooseVariationWinnerSuccess = createAction(REQUESTED_CHOOSE_VARIATION_WINNER_SUCCEEDED, null, contentType => Object.assign({}, createTranslatedSuccessNotification(contentType, 'chooseVariationWinner'), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'chooseVariationWinner',
  'page-type': contentType,
  screen: 'detail',
  status: 'success'
})));
export const rerunVariation = createAction(RERAN_VARIATION, ({
  abTestId,
  contentType,
  variationId
}) => ({
  abTestId,
  contentType,
  variationId
}));
export const requestRerunVariation = createAction(REQUESTED_RERUN_VARIATION);
export const requestedRerunVariationFailure = createAction(REQUESTED_RERUN_VARIATION_FAILED, error => ({
  error
}), (error, contentType) => Object.assign({}, createTranslatedDangerNotification(contentType, 'rerunVariation', error), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'rerunVariation',
  'page-type': contentType,
  screen: 'detail',
  status: 'fail'
})));
export const requestedRerunVariationSuccess = createAction(REQUESTED_RERUN_VARIATION_SUCCEEDED, null, contentType => Object.assign({}, createTranslatedSuccessNotification(contentType, 'rerunVariation'), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'rerunVariation',
  'page-type': contentType,
  screen: 'detail',
  status: 'success'
})));
export const createVariation = createAction(CREATED_VARIATION, ({
  categoryId,
  contentType,
  id,
  name
}) => ({
  categoryId,
  contentType,
  id,
  name
}));
export const requestCreateVariation = createAction(REQUESTED_CREATED_VARIATION);
export const requestedCreateVariationFailure = createAction(REQUESTED_CREATED_VARIATION_FAILED, error => ({
  error
}), (error, contentType) => Object.assign({}, createTranslatedDangerNotification(contentType, 'createVariation', error), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'createVariation',
  'page-type': contentType,
  screen: 'detail',
  status: 'fail'
})));
export const requestedCreateVariationSuccess = createAction(REQUESTED_CREATED_VARIATION_SUCCEEDED, null, contentType => Object.assign({}, createTranslatedSuccessNotification(contentType, 'createVariation'), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'createVariation',
  'page-type': contentType,
  screen: 'detail',
  status: 'success'
})));